// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Untagged_TypeCheck from "../Untagged.TypeCheck/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var DocumentStyle = function (x) {
    return x;
};
var tsBridgeDocumentStyle = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("DocumentStyle")("__brandDocumentStyle"));
    }
};
var writeDocumentStyle = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showDocumentStyle = Data_Show.showString;
var readDocumentStyle = Simple_JSON.readString;
var ordDocumentStyle = Data_Ord.ordString;
var newtypeDocumentStyle = {
    Coercible0: function () {
        return undefined;
    }
};
var makeDocumentStyle = DocumentStyle;
var hasRuntimeTypeDocumentStyle = Untagged_TypeCheck.hasRuntimeTypeString;
var eqDocumentStyle = Data_Eq.eqString;
export {
    DocumentStyle,
    makeDocumentStyle,
    unwrap,
    newtypeDocumentStyle,
    eqDocumentStyle,
    ordDocumentStyle,
    showDocumentStyle,
    readDocumentStyle,
    writeDocumentStyle,
    hasRuntimeTypeDocumentStyle,
    tsBridgeDocumentStyle
};
//# sourceMappingURL=index.js.map
